// extracted by mini-css-extract-plugin
export default {"section":"social-sections-HeaderSection__section--125AG","separated_cluster":"social-sections-HeaderSection__separated_cluster--2ZC95"};